export default "__VITE_ASSET__24f60454__$_?component__"